import EnumItem from '../../../common/utils/Enum'
import { i18n } from '../../../common/utils/i18n'

export default new EnumItem({
  LLC: { value: 4, text: i18n.gettext('公司') },
  PERSONAL: { value: 3, text: i18n.gettext('个人') }
})
